import { CustomPageQuery, CUSTOM_PAGE_QUERY } from '@layouts/custom-page'
import { fetchSSRData } from '@lib/ssr-fetch'

const ROUTE = '/partner/'

function PartnerSlugPage(props) {
  return <CustomPageQuery {...props} route={ROUTE} />
}

PartnerSlugPage.getInitialProps = async ({ query, asPath }) => {
  const where = query.slug
    ? { route: ROUTE, slug: query.slug }
    : { route: ROUTE, slug_exists: false }

  const result = await fetchSSRData({
    query,
    graphqlQuery: CUSTOM_PAGE_QUERY,
    variables: { where, preview: query.preview },
    transform: (data) => data?.customPageCollection?.items?.[0],
  })
  return { query, asPath, ssrData: result.data }
}

export default PartnerSlugPage
